module.exports = __webpack_public_path__ + "img/@infogresik.8f37fbe1.png";